export const types = {
    login: 'AUTH: LOGIN',
    logout: 'AUTH: LOGOUT',
    setSidebar: 'UI: SET SIDEBAR SHOW',
};
